import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { termsSections } from './termsContent';

const TermsAndConditions = ({ language }) => {
  const isRo = language === 'ro';
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#faf9f7] py-24 sm:py-32" data-testid="terms-page">
      <div className="container mx-auto px-6 sm:px-8 lg:px-12 max-w-4xl">
        <button
          onClick={() => navigate('/')}
          className="flex items-center text-[#334d6e] hover:text-[#0D1B3E] font-body text-sm mb-8 transition-colors"
        >
          <ArrowLeft size={18} className="mr-2" />
          {isRo ? 'Înapoi la pagina principală' : 'Back to Home'}
        </button>

        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#0D1B3E] mb-12">
          {isRo ? 'Termeni și condiții generale – Montréon' : 'General Terms and Conditions – Montréon'}
        </h1>

        <div className="prose prose-lg max-w-none font-body text-[#334d6e] space-y-8">
          <p className="text-sm" data-testid="terms-last-updated">
            {isRo ? 'Data ultimei actualizări: 8 octombrie 2026' : 'Last updated: 8 October 2026'}
          </p>

          <section data-testid="terms-operator">
            <h2 className="font-display text-xl text-[#0D1B3E] mt-8 mb-4">
              1. {isRo ? 'Operatorul website-ului și date de contact' : 'Website operator and contact details'}
            </h2>
            <p><strong>Quantive Endeavors SRL</strong><br />
            Str. Avram Iancu nr. 56, ap. 2, Brașov<br />
            CUI 54042200</p>
            <p>E-mail: <a href="mailto:contact@montreon.ro" className="text-[#10B981]">contact@montreon.ro</a><br />
            {isRo ? 'Telefon' : 'Phone'}: <a href="tel:+40726375166" className="text-[#10B981]">+40 726 375 166</a><br />
            Website: <a href="https://montreon.ro" className="text-[#10B981]">https://montreon.ro</a></p>
            <p>{isRo
              ? 'Prezentul document reglementează utilizarea website-ului și rezervarea serviciilor de transfer aeroport, tururi turistice private și transport corporate.'
              : 'This document governs the use of the website and the booking of airport transfer, private touristic tour and corporate transport services.'}</p>
            <p>{isRo
              ? '„Clientul” este persoana fizică sau juridică ce solicită și contractează serviciile. „Pasagerul” este persoana care beneficiază efectiv de transport.'
              : '"The Client" is the natural or legal person who requests and contracts the services. "The Passenger" is the person who actually benefits from the transport.'}</p>
          </section>

          {termsSections.map((s, i) => (
            <section key={i} data-testid={`terms-section-${i + 2}`}>
              <h2 className="font-display text-xl text-[#0D1B3E] mt-8 mb-4">
                {i + 2}. {isRo ? s.titleRo : s.titleEn}
              </h2>
              {(isRo ? s.ro : s.en).map((block, j) =>
                Array.isArray(block)
                  ? <ul key={j} className="list-disc pl-6 space-y-1">{block.map((li, k) => <li key={k}>{li}</li>)}</ul>
                  : <p key={j}>{block}</p>
              )}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
